import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { resumeService } from '../services/resume.service';
import { TailoredHistoryItem } from '../types';
import { ResumePreview } from '../components/ResumePreview';

export function PublicTailoredPage() {
    const { publicId } = useParams<{ publicId: string }>();
    const [resume, setResume] = useState<TailoredHistoryItem | null>(null);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            if (!publicId) return;
            try {
                const data = await resumeService.getPublicTailored(publicId);
                setResume(data);
            } catch (err: any) {
                setError('Resume not available.');
            } finally {
                setIsLoading(false);
            }
        };
        load();
    }, [publicId]);

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
            </div>
        );
    }

    if (error || !resume) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <p className="text-gray-700 mb-4">{error || 'Resume not found'}</p>
                    <Link to="/" className="btn btn-primary">
                        Back to Resume Builder
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-white border-b border-gray-200">
                <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3 text-gray-900">
                        <img src="/logo.png" alt="Resume Builder" className="h-8 w-8" />
                        <span className="text-lg font-semibold">Resume Builder</span>
                    </div>
                    <Link to="/" className="btn btn-secondary">
                        Create your own
                    </Link>
                </div>
            </header>

            <main className="max-w-5xl mx-auto px-6 py-10">
                <div className="text-sm text-gray-500 mb-4">Shared tailored resume</div>
                <div className="bg-gray-100 p-4 rounded-xl">
                    <div className="max-w-[8.5in] mx-auto">
                        <ResumePreview data={resume.data} template={resume.template} />
                    </div>
                </div>
            </main>
        </div>
    );
}
